// Base URLs read directly from environment
export const getBaseUrl = () => process.env.REACT_APP_API_BASE_URL || "https://localhost:7036";
export const getStorageBaseUrl = () => process.env.REACT_APP_STORAGE_URL || "https://localhost:5000/uploads";

// API Endpoints
export const API_ENDPOINTS = {
  // Public endpoints
  BLOGS_LIST: "/public/blogs_list",
  /** Public — published blog by id (no auth). Use for /blog-details pages. */
  BLOG_DETAIL: (id) => `/blog/blog-detail?id=${id}`,
  BLOG_COMMENTS: "/public/blog_comments",
  SAVE_BLOG: "/public/save_blog",
  EDIT_BLOG: "/public/edit_blog",
  DELETE_BLOG: "/public/delete_blog",
  
  // User endpoints
  USERS_LIST: "/public/users_list",
  USER_DETAIL: (id) => `/public/users_list/${id}`,
  SAVE_USER: "/public/save_user",
  EDIT_USER: "/public/edit_user",
  DELETE_USER: "/public/delete_user",
  
  // Auth endpoints
  LOGIN_PORTAL: "/public/login_portal",
  AUTH_LOGIN: "/Auth/login",
  BLOG_ADD: "/blog/addblog",
  BLOG_LIST: "/Blogs/bloglist",
  BLOG_LATEST: "/Blogs/latest",
  BLOG_PUBLIC_LIST: "/blogs/public-list",
  BLOG_DELETE: (id) => `/blogs/delete?id=${id}`,
  /** Admin edit — requires auth */
  BLOG_GET: (id) => `/blogs/get?id=${id}`,
  BLOG_UPDATE: "/blogs/update",

  // Category endpoints (admin; Prefer public-* for anonymous blog UI)
  CATEGORY_LIST: "/category/list",
  CATEGORY_PUBLIC_LIST: "/category/public-list",
  CATEGORY_GET: (id) => `/category/get?id=${id}`,
  CATEGORY_ADD: "/category/add",
  CATEGORY_UPDATE: "/category/update",
  CATEGORY_DELETE: (id) => `/category/delete?id=${id}`,

  // SubCategory endpoints (admin; Prefer public-* for anonymous blog UI)
  SUBCATEGORY_LIST: "/subcategory/list",
  SUBCATEGORY_PUBLIC_LIST: "/subcategory/public-list",
  SUBCATEGORY_GET: (id) => `/subcategory/get?id=${id}`,
  SUBCATEGORY_ADD: "/subcategory/add",
  SUBCATEGORY_UPDATE: "/subcategory/update",
  SUBCATEGORY_DELETE: (id) => `/subcategory/delete?id=${id}`,
  
  // Contact endpoints
  SAVE_CONTACT_FORM: "/public/save_contact_form",

  // CMS – page content (backend should implement: GET returns { [pageId]: { [key]: string } }, POST saves)
  CMS_CONTENT_GET: "/api/cms/content",
  CMS_CONTENT_SAVE: "/api/cms/content"
};

// Helper function to get full URL
export const getApiUrl = (endpoint) => `${getBaseUrl()}${endpoint}`;

// Helper function to get storage URL
export const getStorageUrl = (path) => `${getStorageBaseUrl()}/${path}`;

